module.exports = __webpack_public_path__ + "img/default-new-school-avatar-missing.535105c0.png";